import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';
import { MediaQuery as MQ } from '../../../media-query';
import TCODMobile from './mobile';
import TCODNonMobile from './non-mobile';

class Component extends BaseComponent {
    componentWillMount() {
        const date = this.props.date || moment().format('YYYY-MM-DD');

        this.setState({date: date});

        this.props.requireTCOD(date);
    }

    render() {
        if (MQ.isMobile()) {
            return (
                <daily-tarot-card>
                    <TCODMobile date={this.state.date} />
                </daily-tarot-card>
            );
        }

        return (
            <daily-tarot-card>
                <TCODNonMobile date={this.state.date} />
            </daily-tarot-card>
        );
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    requireTCOD: (date) => dispatch({ type: 'tcod:required', payload: date }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./app/components/daily/tarot-card/index.js